import React from 'react'

const BarEMPRESA = () => {
    return (
        <div className='flex flex-wrap justify-between '>
            <div className='mx-auto lg:mx-40'>
                <div>
                    <div className="py-4">
                        <div className="animation-ronsof-one font-ronsof-three font-al-7  ">Clientes Satifeitos</div>                        
                    </div>
                </div>
            </div>
            <hr className='w-full'/>
        </div>
    )
}
export default BarEMPRESA